import { render, staticRenderFns } from "./AddUpdateModal.vue?vue&type=template&id=0ffd91b8&scoped=true&"
import script from "./AddUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./AddUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddUpdateModal.vue?vue&type=style&index=0&id=0ffd91b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd91b8",
  null
  
)

export default component.exports